
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 164 15","fill":"none","preserveAspectRatio":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 3.652s210.547-4.94 151.581-1.335c-27.295 1.67-97.96 8.435-70.186 9.011C114.564 11.996 118.95 14 118.95 14","stroke":"#56BFC7","stroke-width":"2"}})])
          )
        }
      }
    